import { setSupervisorRatings, TrainingDocument } from '~/monolith-api';
import { useRegisteredMutation } from '~/queries';

export function useSetSupervisorRatings(
   userids: number[],
   docs: TrainingDocument[],
   rating: number,
   teamid?: number
) {
   return useRegisteredMutation('supervisor-rating', async (): Promise<null> => {
      return await setSupervisorRatings(userids, docs, rating, teamid);
   });
}
